export const GET_CUSTOMER_PRINTERS = 'GET_CUSTOMER_PRINTERS';
export const GET_CUSTOMER_PRINTERS_SUCCESS = 'GET_CUSTOMER_PRINTERS_SUCCESS';
export const GET_CUSTOMER_PRINTERS_FAILURE = 'GET_CUSTOMER_PRINTERS_FAILURE';

export const ADD_ACTION_PRINTERS = 'ADD_ACTION_PRINTERS';
export const ADD_ACTION_PRINTERS_SUCCESS = 'ADD_ACTION_PRINTERS_SUCCESS';
export const ADD_ACTION_PRINTERS_FAILURE = 'ADD_ACTION_PRINTERS_FAILURE';

export const SUBSCRIBE_TO_ADD_PRINTER_SUCCESS = 'SUBSCRIBE_TO_ADD_PRINTER_SUCCESS';
export const SUBSCRIBE_TO_ADD_PRINTER_FAILURE = 'SUBSCRIBE_TO_ADD_PRINTER_FAILURE';

export const SUBSCRIBE_TO_UPDATE_PRINTER_SUCCESS = 'SUBSCRIBE_TO_UPDATE_PRINTER_SUCCESS';
export const SUBSCRIBE_TO_UPDATE_PRINTER_FAILURE = 'SUBSCRIBE_TO_UPDATE_PRINTER_FAILURE';

export const SUBSCRIBE_TO_PRINTERDETAIL_UPDATE_SUCCESS = 'SUBSCRIBE_TO_PRINTERDETAIL_UPDATE_SUCCESS';
export const SUBSCRIBE_TO_PRINTERDETAIL_UPDATE_FAILURE = 'SUBSCRIBE_TO_PRINTERDETAIL_UPDATE_FAILURE';

export const SUBSCRIBE_TO_DELETE_PRINTER_SUCCESS = 'SUBSCRIBE_TO_DELETE_PRINTER_SUCCESS';
export const SUBSCRIBE_TO_DELETE_PRINTER_FAILURE = 'SUBSCRIBE_TO_DELETE_PRINTER_FAILURE';
